import QueryContainer from '@components/setup/QueryContainer';
import { RouterProvider } from '@tanstack/react-router';
import { AllEnterpriseModule, LicenseManager, ModuleRegistry } from 'ag-grid-enterprise';
import React, { type FC } from 'react';

import { useAuthStatus } from './hooks';
import './i18n.ts';
import { queryClient, router } from './lib/index.ts';

ModuleRegistry.registerModules([AllEnterpriseModule]);

LicenseManager.setLicenseKey(import.meta.env.VITE_AG_GRID_LICENSE);

const RouterProviderWithContext: FC = () => {
  const authentication = useAuthStatus();

  return <RouterProvider context={{ authentication, queryClient }} router={router} />;
};

const App: FC = () => {
  return (
    <QueryContainer queryClient={queryClient}>
      <RouterProviderWithContext />
    </QueryContainer>
  );
};

export default App;
